import React, {Component} from 'react'
import { Grid,Content } from '../../_core/components'
import { Data } from '../../_core/models'

class Footer extends Component {

  constructor() {
    super()

  }

  

  render () {
      return (
      <Data>
      {({globals})=>(

          <Grid modifiers={['footer']}>
                <div className="Grid-item">
                  <Content html={globals.footerSignOff} />
                </div>
                <div className="Grid-item">
                  <Content html={globals.footerContact} />
                </div>
                <div className="Grid-item">
                  <Content html={globals.footerAddress} />
                 
                </div>
              </Grid>

      )}
      </Data>
      )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/js/components/Footer/Footer.jsx